import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IGetChallengesNeedingAudioV1Body } from './get-challenges-needing-audio-v1-request';
import type { IGetChallengesNeedingAudioV1Response } from './get-challenges-needing-audio-v1-response';
import { getChallengesNeedingAudioV1ResponseSchema } from './get-challenges-needing-audio-v1-response';

export async function getChallengesNeedingAudioV1Api(
  body: IGetChallengesNeedingAudioV1Body,
): Promise<IValidatedResponse<IGetChallengesNeedingAudioV1Response>> {
  return postRequest<IGetChallengesNeedingAudioV1Response>({
    path: '/sys/audio/v1/challenges-needing-audio',
    body,
    schema: getChallengesNeedingAudioV1ResponseSchema,
  });
}
